export default __webpack_public_path__ + "static/media/login-decoration-end.9c74f579.svg";